<template>
  <div class="conteudo-sala container-fluid">
    <div class="topo-conteudo">
      <div class="d-flex float-left">
        <button type="button" class="btn sidebar-collapse" @click="toggleSideBar()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <h2>{{ titulo }}</h2>
      </div>
      <div class="d-flex align-items-center comp-star float-right">

        <compartilhar-topico-sala-aula :link-compartilhamento="linkCompartilhamento" v-if="false"/>

        <avaliacao-topico :ementa-id="ementaId" :rating="rating"/>
      </div>
      <div class="clearfix"></div>
    </div>

    <slot></slot>

    <controle-topico :controle-topico="controleTopico"/>

    <apoio-topico :referencias="referencias" :resumos="resumos" :professores="professores" :tipo-topico="tipoTopico" :ementa-id="ementaId" :anotacoes="anotacoes" :licao="licao"/>

    <ferramenta-estudo :licaoPai="licao" :resumos="resumos" :itens-memorize="itensMemorize" :referencias="referencias" :quiz="quiz" :simulados="simulados" :curso="ementaCurso" :decks="decks"/>

  </div>
</template>

<script>
import $ from 'jquery'
import ControleTopico from '@/modules/SalaAula/components/ControleTopico'
import ApoioTopico from '@/modules/SalaAula/components/ApoioTopico'
import AvaliacaoTopico from '@/modules/SalaAula/components/AvaliacaoTopico'
import CompartilharTopicoSalaAula from '@/modules/SalaAula/components/CompartilharTopicoSalaAula'
import FerramentaEstudo from '@/modules/SalaAula/components/ferramenta-estudo/FerramentaEstudo'

export default {
  name: 'TopicoSalaAula',
  components: { FerramentaEstudo, CompartilharTopicoSalaAula, AvaliacaoTopico, ApoioTopico, ControleTopico },
  props: {
    titulo: {
      type: String,
      required: true
    },
    ementaCurso: Object
  },
  data () {
    return {
      ementaId: 0,
      tipoTopico: null,
      licao: null,
      linkCompartilhamento: '',
      rating: 0,
      professores: [],
      resumos: [],
      simulados: [],
      itensMemorize: [],
      referencias: [],
      quiz: {},
      anotacoes: '',
      controleTopico: {
        anterior: { nome: '', url: '' },
        proximo: { nome: '', url: '' }
      },
      decks: []
    }
  },
  methods: {
    toggleSideBar: function () {
      $('.sidebar').toggleClass('active')
    },

    obterReferenciaTipoTopico: function (modulos, url) {
      const partesURL = url.split('/')
      const curso = partesURL[0]

      const modulo = modulos.find(modulo => modulo.referencia === partesURL[1])
      const licao = modulo.licoes.find(licao => licao.referencia === partesURL[2])
      const topico = licao.topicos.find(topico => topico.referencia === partesURL[3])

      return `/sala-de-aula/${curso}/${modulo.referencia}/${licao.referencia}/${topico.referencia}`
    },

    montarEstruturaSalaAula: function () {
      const estruturaCurso = this.ementaCurso.curso_estrutura

      this.ementaId = this.ementaCurso.topico_escolhido.ementa_id
      this.linkCompartilhamento = this.ementaCurso.url_curta_topico

      let topicoId
      if (this.ementaCurso.topico_escolhido.id) topicoId = this.ementaCurso.topico_escolhido.id
      else if (this.ementaCurso.topico_escolhido.topico_id) topicoId = this.ementaCurso.topico_escolhido.topico_id

      this.tipoTopico = this.ementaCurso.topico_escolhido.tipo

      const licoes = estruturaCurso.modulos.flatMap(modulo => modulo.licoes)
      const licaoTopico = licoes.find(licao => licao.topicos.find(topico => topico.id === topicoId))

      const nomeCategoria = this.ementaCurso.breadcrumb && this.ementaCurso.breadcrumb.nome_categoria ? this.ementaCurso.breadcrumb.nome_categoria : ''
      this.licao = { id: licaoTopico.id, nome: licaoTopico.titulo, nomeCategoria: nomeCategoria, curso: { id: estruturaCurso.id, nome: estruturaCurso.nome } }

      this.anotacoes = this.ementaCurso.anotacoes && this.ementaCurso.anotacoes.length ? this.ementaCurso.anotacoes[this.ementaCurso.anotacoes.length - 1].anotacao : ''
      this.rating = this.ementaCurso.avaliacao && this.ementaCurso.avaliacao.data && this.ementaCurso.avaliacao.data.length > 0 ? this.ementaCurso.avaliacao.data[0] : 0

      let professores = []

      if (this.ementaCurso.topico_escolhido.coordenador && this.ementaCurso.topico_escolhido.professor &&
        this.ementaCurso.topico_escolhido.coordenador.id === this.ementaCurso.topico_escolhido.professor.id) {
        professores.push({
          nome: this.ementaCurso.topico_escolhido.coordenador.nome,
          foto: this.ementaCurso.topico_escolhido.coordenador.fotoProf,
          curriculo: this.ementaCurso.topico_escolhido.coordenador.curriculo,
          coordenadorEProfessor: 1
        })
      } else {
        if (this.ementaCurso.topico_escolhido.coordenador) {
          professores.push({
            nome: this.ementaCurso.topico_escolhido.coordenador.nome,
            foto: this.ementaCurso.topico_escolhido.coordenador.fotoProf,
            curriculo: this.ementaCurso.topico_escolhido.coordenador.curriculo,
            coordenador: 1
          })
        }
        if (this.ementaCurso.topico_escolhido.professor) {
          professores.push({
            nome: this.ementaCurso.topico_escolhido.professor.nome,
            foto: this.ementaCurso.topico_escolhido.professor.fotoProf,
            curriculo: this.ementaCurso.topico_escolhido.professor.curriculo
          })
        }
      }

      this.professores = professores
      this.simulados = this.ementaCurso.simulados
      this.decks = this.ementaCurso.decks

      this.resumos = this.ementaCurso.resumos.filter(resumo => resumo.modulo_id === this.ementaCurso.topico_escolhido.modulo_id)
      this.referencias = this.ementaCurso.referencias.filter(referencia => referencia.licao_id === this.licao.id)
      this.itensMemorize = this.ementaCurso.memorizes.filter(memorize => !memorize.deletado)

      this.controleTopico = {
        anterior: {
          nome: this.ementaCurso.nome_topico_anterior,
          url: this.obterReferenciaTipoTopico(estruturaCurso.modulos, this.ementaCurso.topico_anterior)
        },
        proximo: {
          nome: this.ementaCurso.nome_topico_posterior,
          url: this.obterReferenciaTipoTopico(estruturaCurso.modulos, this.ementaCurso.topico_posterior)
        }
      }
      this.quiz = this.ementaCurso.quiz
      this.$store.dispatch('defineControleTopico', this.controleTopico)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
  section.classroom .conteudo-sala button.sidebar-collapse::after {
    margin-left: 1px;
  }

  @media (max-width: 768px) {
    section.classroom .conteudo-sala button.sidebar-collapse::after {
      margin-left: 5px;
    }
  }
</style>
